import React from 'react';
import classNames from 'classnames';
import CurrentWaveRating from 'components/CurrentWaveRating';
import SpotReportSummary from 'components/SpotReportSummary';
import { SpotTravel } from 'types/spot';
import { Units } from 'types/units';

interface SpotDetailsProps {
  spot: SpotTravel;
  units: Units;
  showPremiumCamCTA?: boolean;
}

const getDetailsClassName = (showPremiumCamCTA: boolean) =>
  classNames({
    'quiver-spot-details': true,
    'quiver-spot-details--premium-cta': showPremiumCamCTA,
  });

const SpotDetails: React.FC<SpotDetailsProps> = ({ spot, units, showPremiumCamCTA = false }) => (
  <div className={getDetailsClassName(showPremiumCamCTA)}>
    <h3 className="quiver-spot-details__name">{spot.name}</h3>

    {spot.conditions.value && <CurrentWaveRating rating={spot.conditions.value} />}
    <SpotReportSummary
      waveHeight={spot?.waveHeight}
      tide={spot?.tide}
      wind={spot?.wind}
      units={units}
    />
  </div>
);

export default SpotDetails;
